var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPizza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 335,
    viewBox: "0 0 408 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1698_444)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.869 455.135C123.453 455.839 121.036 456.518 118.619 457.172L10.0828 86.7261L368.033 237.559C326.045 339.394 239.843 421.91 125.869 455.135Z",
    fill: "#CA793F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.357 398.493C106.721 399.261 104.083 399.994 101.444 400.691L6.48171 85.2093L314.113 214.839C278.558 300.773 205.676 370.415 109.357 398.493Z",
    fill: "#FFD770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.129 309.328C208.607 322.687 221.784 346.449 187.262 363.804C152.257 393.799 206.741 371.667 222.48 373.849C238.22 376.031 289.049 312.779 306.17 303.621C323.291 294.463 333.839 237.745 314.779 243.822C295.718 249.899 299.577 252.42 275.893 280.157C252.21 307.893 221.651 295.969 215.129 309.328Z",
    fill: "#CA793F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.629,
    cy: 309.817,
    r: 36.5,
    transform: "rotate(163.748 136.629 309.817)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.682,
    cy: 219.109,
    r: 36.5,
    transform: "rotate(163.748 222.682 219.109)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.428 125.652C99.3524 133.063 98.6886 141.533 101.109 149.835C106.751 169.188 127.013 180.303 146.365 174.662C157.128 171.524 165.342 163.866 169.545 154.356L102.428 125.652Z",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1347 244.566L37.155 179.381C40.685 176.638 44.7818 174.502 49.3344 173.175C68.6873 167.533 88.9493 178.648 94.5909 198.001C100.233 217.354 89.1174 237.616 69.7645 243.258C65.204 244.587 60.593 244.986 56.1347 244.566Z",
    fill: "#832120"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1698_444",
    x: 2.48171,
    y: 85.2094,
    width: 369.551,
    height: 379.962,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1698_444"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1698_444",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizza);
export default __webpack_public_path__ + "static/media/pizza.fab48aa0a84ecefc07ab79215096ac6a.svg";
export { ForwardRef as ReactComponent };